/**
 * Ryan O'Dowd
 * 2026-01-11
 * © Copyright 2026 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts}) => {
  return {
    boldText: {
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
